// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__Rfto9","contentWrapper":"Modal_contentWrapper__k+GTC","alert":"Modal_alert__tf2Ms","title":"Modal_title__DwVsm"};